import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dbe144a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "course-name" }
const _hoisted_3 = { class: "catalog" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "plan-name" }
const _hoisted_6 = {
  key: 0,
  class: "parts"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))


import {CircleCheck, Clock, Remove} from '@element-plus/icons'
import {CoursePlanPartVO, CoursePlanVO, CourseVO} from "@/apis/course";
import usePartConvert from "@/composables/usePartConvert";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainNav',
  props: {
    courseVO: {},
    currentPlan: {},
    currentPart: {}
  },
  emits: ['part-change'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props
const {convertPartType} = usePartConvert()

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.courseVO.courseName), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseVO.plans.filter(plan => plan.coursePlanType === 'PLAN'), (plan) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "plan",
          key: 'plan'+plan.id
        }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (plan.show = !plan.show)
          }, [
            _createVNode(_component_el_tooltip, {
              placement: "right",
              "show-after": 500
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(plan.planName), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(plan.planName), 1)
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_4),
          (plan.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.parts, (part) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "part",
                    key: 'part'+part.id,
                    onClick: ($event: any) => (emits('part-change', {plan, part}))
                  }, [
                    _createVNode(_component_el_tooltip, {
                      placement: "right",
                      "show-after": 500
                    }, {
                      content: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(convertPartType)(part)) + " ", 1),
                        _hoisted_8,
                        _createTextVNode(" " + _toDisplayString(part.partName), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["part-name", part.id === _ctx.currentPart.id && 'active'])
                        }, [
                          (part.userCoursePlanPart.status === 'FINISHED')
                            ? (_openBlock(), _createBlock(_unref(CircleCheck), {
                                key: 0,
                                class: "icon"
                              }))
                            : (part.userCoursePlanPart.status === 'LEARNING')
                              ? (_openBlock(), _createBlock(_unref(Clock), {
                                  key: 1,
                                  class: "icon"
                                }))
                              : (part.userCoursePlanPart.status === 'UNLEARNED')
                                ? (_openBlock(), _createBlock(_unref(Remove), {
                                    key: 2,
                                    class: "icon"
                                  }))
                                : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(convertPartType)(part) + part.partName), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1024)
                  ], 8, _hoisted_7))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})